import script from "./SuperAdminSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperAdminSideBar.vue?vue&type=script&setup=true&lang=js"

import "./SuperAdminSideBar.vue?vue&type=style&index=0&id=01f9f6e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f9f6e2"]])

export default __exports__